<template>
  <div class="container">
    <Banner></Banner>
    <div :class="{ 'fixed-top': showTopBtns }">
      <div class="tab">
        <span @click="showActions1 = true"
          >{{ local1 }}<van-icon name="arrow-down"
        /></span>
        <span @click="showActions2 = true"
          >{{ local2 }}<van-icon name="arrow-down"
        /></span>
        <span @click="showActions3 = true"
          >{{ local3 }}<van-icon name="arrow-down"
        /></span>
      </div>

      <div>
        <van-action-sheet
          class="pop-div100"
          safe-area-inset-bottom
          v-model="showActions1"
          :actions="actions1"
          close-on-click-action
          @select="onSelect1"
        />
        <van-action-sheet
          class="pop-div100"
          safe-area-inset-bottom
          v-model="showActions2"
          :actions="actions2"
          close-on-click-action
          @select="onSelect2"
        />
      </div>

      <van-action-sheet
        class="pop-div100"
        safe-area-inset-bottom
        v-model="showActions3"
        :actions="actions3"
        close-on-click-action
        @select="onSelect3"
      />
    </div>

    <div>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list-item"
        @click="goDetail(item.id)"
      >
        <div class="one">{{ item.post }}</div>
        <div class="two">
          {{ item.region }}· {{ item.business }}· {{ item.profession }}
        </div>
      </div>
    </div>
  </div>
</template>


  <script>
import dataList from "@/utils/data.json";
import Banner from "@/views/banner/banner.vue";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      list: [],
      showActions1: false,
      showActions2: false,

      showActions3: false,

      local1: "工作地点",
      local2: "业务线",
      local3: "职务类别",
      localVal1: "",
      localVal2: "",
      localVal3: "",
      actions1: [
        // { name: "工作地点", value: "" }, //工作地点
        { name: "上海", value: "上海" }, //工作地点
        { name: "重庆", value: "重庆" },
        { name: "上海或深圳", value: "上海或深圳" },
      ],
      actions2: [
        // { name: "业务线", value: "" }, //业务线
        { name: "研发", value: "研发" }, //业务线
        { name: "发行", value: "发行" },
      ],
      actions3: [
        // { name: "职务类别", value: "职务类别" }, //职务类别
        { name: "美术", value: "美术" }, //职务类别
        { name: "策划", value: "策划" },
        { name: "开发", value: "开发" },
        { name: "剧情", value: "剧情" },
      ],
      showTopBtns: false,
    };
  },
  mounted() {
    this.list = dataList;
    // 事件监听
    window.addEventListener("scroll", this.listenBottomOut);
    window.scrollTo(0, 0);
  },
  destroyed() {
    // 离开页面取消监听
    window.removeEventListener("scroll", this.listenBottomOut, false);
  },
  methods: {
    // 触底触发函数
    listenBottomOut() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 120) {
        this.showTopBtns = true;
      } else {
        this.showTopBtns = false;
      }
    },
    onSelect1(val) {
      this.local1 = val.name;
      this.localVal1 = val.value;
      this.search();
      // this.list = this.list.filter((item) => item.region == val.value);
      // console.log(this.list);
    },
    onSelect2(val) {
      this.local2 = val.name;
      this.localVal2 = val.value;
      this.search();

      // this.list = this.list.filter((item) => item.business == val.value);
      // console.log(this.list);
    },
    onSelect3(val) {
      this.local3 = val.name;
      this.localVal3 = val.value;
      this.search();

      // this.list = this.list.filter((item) => item.profession == val.value);
      // console.log(this.list);
    },
    search() {
      // this.list.forEach((item) => {
      //   if (!this.localVal1 && item.region == this.localVal1) {
      //   }
      // });
      if (this.localVal1 && this.localVal2 && this.localVal3) {
        this.list = dataList.filter(
          (item) =>
            item.region == this.localVal1 &&
            item.business == this.localVal2 &&
            item.profession == this.localVal3
        );
      } else if (!this.localVal1 && this.localVal2 && this.localVal3) {
        this.list = dataList.filter(
          (item) =>
            item.business == this.localVal2 && item.profession == this.localVal3
        );
      } else if (this.localVal1 && !this.localVal2 && this.localVal3) {
        this.list = dataList.filter(
          (item) =>
            item.region == this.localVal1 && item.profession == this.localVal3
        );
      } else if (this.localVal1 && this.localVal2 && !this.localVal3) {
        this.list = dataList.filter(
          (item) =>
            item.region == this.localVal1 && item.business == this.localVal2
        );
      } else if (this.localVal1 && !this.localVal2 && !this.localVal3) {
        this.list = dataList.filter((item) => item.region == this.localVal1);
      } else if (!this.localVal1 && this.localVal2 && !this.localVal3) {
        this.list = dataList.filter((item) => item.business == this.localVal2);
      } else if (!this.localVal1 && !this.localVal2 && this.localVal3) {
        this.list = dataList.filter(
          (item) => item.profession == this.localVal3
        );
      }

      // this.localVal1 &&
      //   (this.list = this.list.filter((item) => item.region == this.localVal1));
      // this.localVal2 &&
      //   (this.list = this.list.filter(
      //     (item) => item.business == this.localVal2
      //   ));
      // this.localVal3 &&
      //   (this.list = this.list.filter(
      //     (item) => item.profession == this.localVal3
      //   ));
      // console.log(this.list);
    },
    goDetail(item) {
      // console.log(item, "item===");
      this.$router.push({
        path: `/jobs/detail/${item}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/mixins.scss";
.container{
  width: 50%;
  margin: 0 auto;
}
.tab {
  margin-top:10px;
  padding-bottom:10px;
  padding-left:10px;
  & > span {
    font-size: 14px;
    padding:5px 10px;
    margin-right: 10px;
    border-radius:10px;
    background: #f5f6f7;
  }
}
.list-item {
  border-bottom: 1px solid #e7e1e1;
  padding:10px;

  .one {
    color: #1f2329;
    font-size:18px;
    line-height: 2;
  }

  .two {
    color: #646a73;
    font-size: 14px;
    line-height: 2;
  }
}
.fixed-top {
  z-index: 34;
  position: fixed;
  width: 50%;
  top: 0;
  background: #fff;
  box-shadow: 0px 0px 5px #999;
}
</style>